import { useEffect } from "react";

/**
 * Add `<meta name="robots" content="noindex, nofollow">` while the calling
 * component is mounted, and remove it on unmount so the rest of the app is
 * unaffected.
 */
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
